import React, { useState } from "react";

const tabItems = [
  "Service Provider",

  "Offtake Partner",

  "Input Supplier",

  "Development Partner",
  "Education",
  "Institution",
  "Community",
  "Investor",
  "Contract",
];

const TabsSection = () => {
  const [activeTab, setActiveTab] = useState(tabItems[0]);

  return (
    <div className="flex flex-wrap md:gap-1 bg-[#F1F1F1] md:py-3 py-1 lg:w-full  md:w-[1210px] w-full">
      {tabItems.map((item) => (
        <div
          key={item}
          onClick={() => setActiveTab(item)}
          className="cursor-pointer md:px-4 px-[2px]   flex flex-col   items-center md:w-[130px] rounded"
        >
          <span className="text-center md:text-[16px] text-[4px] font-extrabold md:h-[30px] leading-tight md:mb-2">{item}</span>
          <div
            className="md:mt-2 mt-1 md:w-[130px] w-[30px] md:h-[4px]  h-[2px] rounded-sm  "
            style={{
              backgroundColor: activeTab === item ? "#FCC153" : "#D9D9D9",
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default TabsSection;
